
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-corporate",
      function () {
        return require("private-next-pages/for-corporate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-corporate"])
      });
    }
  